import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Component, OnInit, ViewEncapsulation, Input, OnChanges, EventEmitter, Output, OnDestroy } from '@angular/core';
import { RegisterOfBenefactorsService } from '../../register-of-benefactors.service';
import { RegisterOfBenefactorsEventType } from '../../register-of-benefactors.event.type';
import { AppEventDispatcher } from '../../../../utils/AppEventDispatcher';
import { BenefactorDataModel } from '../../../models/benefactorData';
import { TweenMax, Quint } from 'gsap';
import { Bank } from './../../../models/banks';
import { Observable } from 'rxjs/Observable';
import { EventTypes } from '../../../../shared/EventTypes';
import { startWith } from 'rxjs/operators/startWith';
import { map } from 'rxjs/operators/map';
import { Modality } from '../../../models/modality';
import { Ownership } from '../../../models/ownership';
import { Auth } from './../../../../autentication/Auth';

@Component({
	selector: 'app-benefactor-data',
	templateUrl: './benefactor-data.component.html',
	styleUrls: ['./benefactor-data.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class BenefactorDataComponent implements OnInit, OnDestroy {

	@Input() benefactorData: BenefactorDataModel;
	@Input() submited = false;
	@Output() setForm: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();
	@Output() setTitle: EventEmitter<any> = new EventEmitter<any>();


	private view = '[data-component="benefactor-data"]';
	private viewHeight = 0;
	activeBackButton: boolean = false;
	active: boolean = false;

	form: FormGroup;
	private banks: Array<Bank> = [];
	public filteredBanks: Observable<Bank[]>;
	private modalities: Array<Modality> = [];
	public ownerships: Array<Ownership> = [];
	hideAgency: boolean = false;

	public agency = '';

	cpfCnpj;
	cpfCnpjOld;

	account;
	accountOld;

	constructor(private formBuilder: FormBuilder, private benefactorsService: RegisterOfBenefactorsService) {
		this.form = this.formBuilder.group({
			id: [],
			bank: ['', Validators.required],
			modality: [null, Validators.required],
			agency: ['', Validators.compose([Validators.required, Validators.pattern(new RegExp(/[0-9]{4,5}/))])],
			account: ['', Validators.required],
			ownership: [1, Validators.required],
			name: [null],
			cpfCnpj: [null],
		});

		this.modalities = [new Modality('CC', 'Conta Corrente'), new Modality('PP', 'Conta Poupança'), new Modality('PG', 'Conta Pagamento')];
		this.ownerships = [new Ownership(1, 'Mesma Titularidade'), new Ownership(2, 'Outra Titularidade')];
	}

	ngOnInit() {
		if(!this.benefactorData.id) {
			this.form.controls.modality.setValue('CC');
		}

		AppEventDispatcher.listen(RegisterOfBenefactorsEventType.STEPS.BENEFACTOR_ADD.BENEFACTOR_DATA, () => {
			this.active = true;
			this.setForm.emit(this.form);
			this.getBanks();
		});


		AppEventDispatcher.listen(RegisterOfBenefactorsEventType.BENEFACTOR.SEND_DATA, () => {
			this.hide();
		});
	}

	setBenefactorData() {
		this.benefactorData.bankCode =  this.form.controls.bank.value.code;
		this.benefactorData.bankDesc = this.form.controls.bank.value.label;
		this.benefactorData.modality = this.form.controls.modality.value;
		this.benefactorData.agency  = this.form.controls.agency.value;
		this.benefactorData.accountNumber = this.form.controls.account.value.replace(/\D/g, '');
		this.benefactorData.ownership = this.form.controls.ownership.value;

		if (this.form.controls.name.value) {
			this.benefactorData.name = this.form.controls.name.value;
		} else {
			this.benefactorData.name = Auth.getInstance().getUser().name;
		}

		if (this.form.controls.cpfCnpj.value) {
			this.benefactorData.cpfCnpj = this.form.controls.cpfCnpj.value.replace(/\D/g, '');
		} else {
			this.benefactorData.cpfCnpj = Auth.getInstance().getUser().cpfCnpj;
		}
	}

	setFormData() {
		this.form.controls.id.setValue(this.benefactorData.id);
		this.form.controls.name.setValue(this.benefactorData.name);
		this.cpfCnpj = this.benefactorData.cpfCnpj;
		this.form.controls.bank.setValue({
			code: this.benefactorData.bankCode,
			name: this.benefactorData.bankDesc,
			label: this.benefactorData.bankCode + ' - ' + this.benefactorData.bankDesc,
		});
		this.form.controls.modality.setValue(this.benefactorData.modality);
		if (Auth.getInstance().getUser().cpfCnpj !== this.benefactorData.cpfCnpj.replace(/\D/g, '')) {
			this.form.controls.ownership.setValue(2);
		} else {
			this.form.controls.ownership.setValue(1);
		}
		this.agency = this.benefactorData.agency;
		this.account = this.benefactorData.accountNumber;

		this.checkModality(this.benefactorData.modality);
	}

	getBanks() {
		this.preload(true);
		this.benefactorsService.getBanks().subscribe(data => {
			this.banks = data;
			this.filteredBanks = this.form.controls.bank.valueChanges.pipe(
				startWith({} as Bank),
				map(bank => bank && typeof bank === 'object' ? bank.label : bank),
				map(label => label ? this.filter(label) : this.banks.slice())
			);

			this.show();
			this.preload(false);

		});
	}

	filter(val): Bank[] {
		return this.banks.filter(bank => bank.label.includes(val));
	}

	autoCompleteDisplay(bank: Bank): any {
		return bank ? bank.label : bank;
	}

	validateBank(e) {
		if (e.source !== undefined) {
			this.form.controls['bank'].setErrors(null);
		} else {
			this.form.controls['bank'].setErrors({'incorrect': true});
		}
	}

	show() {
		if (this.benefactorData.id) {
			this.setTitle.emit({
				title: 'Editar Favorecido',
			});
			this.setFormData();
		} else {
			this.setTitle.emit({
				title: 'Adicionar favorecido',
			});
		}
		TweenMax.delayedCall(.3, () => {
			const containerHeight = $(this.view).outerHeight() + $('.buttons').outerHeight() + 80;
			this.viewHeight = containerHeight;
			TweenMax.to('.steps-container', .8, { height: containerHeight, ease: Quint.easeOut });
			TweenMax.to(this.view, .8, { left: 0, ease: Quint.easeOut });
		});
	}

	hide() {
		this.setBenefactorData();

		this.preload(true);

		TweenMax.delayedCall(3, () => {
			AppEventDispatcher.dispatch(RegisterOfBenefactorsEventType.STEPS.BENEFACTOR_ADD.BENEFACTOR_CONFIRMATION, {show: true});
			TweenMax.to(this.view, .8, { delay: .4, left: '-100%', ease: Quint.easeOut, onComplete: () => {
				this.active = false;
				this.preload(false);
			}});
		});
	}

	checkModality(value) {
		let containerHeight: number;

		if (value === 'PG') {
			containerHeight = this.getStepHeight() - 80;
			this.hideAgency = true;
			this.form.controls.agency.clearValidators();
			this.form.controls.agency.updateValueAndValidity();
		} else {
			containerHeight = this.getStepHeight();
			this.hideAgency = false;
			this.form.controls.agency.setValidators(Validators.required);
			this.form.controls.agency.updateValueAndValidity();
		}
		TweenMax.to('[data-component="add-benefactors"] .content', .8, { height: containerHeight, ease: Quint.easeOut});
	}

	checkOwnership(value) {
		let containerHeight: number;

		if (value === 2) {
			containerHeight = this.getStepHeight() + 200;
			this.form.controls.name.setValidators(Validators.required);
			this.form.controls.name.updateValueAndValidity();
			this.form.controls.cpfCnpj.setValidators([Validators.required, Validators.minLength(14)]);
			this.form.controls.cpfCnpj.updateValueAndValidity();
		} else {
			containerHeight = this.viewHeight;
			this.form.controls.name.clearValidators();
			this.form.controls.name.updateValueAndValidity();
			this.form.controls.cpfCnpj.clearValidators();
			this.form.controls.cpfCnpj.updateValueAndValidity();
		}
		TweenMax.to('.steps-container', .8, { height: containerHeight, ease: Quint.easeOut });
	}

	accountMask(event) {
		if (event.keyCode === 8) {
		} else if (event.target.value.length <= 21) {
			// remove all mask characters (keep only numeric)
			let newVal = event.target.value.replace(/\D/g, '');


			// don't show braces for empty value
			if (newVal.length === 0) {
				newVal = '';
			} else {
				newVal = newVal.replace(/^(\d{0,20})*(\d{1})/, '$1-$2');
			}

			// set the new value
			this.account = this.account = newVal;
		} else {
			this.account = this.account;
		}
	}

	cpfcnpjMask(event) {
		if (event.keyCode === 8) {
		} else if (event.target.value.length <= 19) {
			// remove all mask characters (keep only numeric)
			let newVal = event.target.value.replace(/\D/g, '');

			// don't show braces for empty value
			if (newVal.length === 0) {
				newVal = '';
			} else if (newVal.length <= 3) {
				newVal = newVal.replace(/^(\d{0,3})/, '$1');
				this.form.controls.cpfCnpj.setValidators([Validators.required, Validators.minLength(14)]);
				this.form.controls.cpfCnpj.updateValueAndValidity();
			} else if (newVal.length <= 6) {
				newVal = newVal.replace(/^(\d{0,3})(\d{0,3})/, '$1.$2');
				this.form.controls.cpfCnpj.setValidators([Validators.required, Validators.minLength(14)]);
				this.form.controls.cpfCnpj.updateValueAndValidity();
			} else if (newVal.length <= 9) {
				newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,2})/, '$1.$2.$3');
				this.form.controls.cpfCnpj.setValidators([Validators.required, Validators.minLength(14)]);
				this.form.controls.cpfCnpj.updateValueAndValidity();
			} else if (newVal.length <= 11) {
				newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,2})/, '$1.$2.$3-$4');
				this.form.controls.cpfCnpj.setValidators([Validators.required, Validators.minLength(14)]);
				this.form.controls.cpfCnpj.updateValueAndValidity();
			} else if (newVal.length <= 12) {
				newVal = newVal.replace(/^(\d{0,2})(\d{0,3})(\d{0,3})(\d{0,4})/, '$1.$2.$3/$4');
				// newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,4})(\d{0,2})/, '$1.$2.$3/$4-$5');
				this.form.controls.cpfCnpj.setValidators([Validators.required, Validators.minLength(18)]);
				this.form.controls.cpfCnpj.updateValueAndValidity();
			} else {
				newVal = newVal.replace(/^(\d{0,2})(\d{0,3})(\d{0,3})(\d{0,4})(\d{0,2})/, '$1.$2.$3/$4-$5');
				this.form.controls.cpfCnpj.setValidators([Validators.required, Validators.minLength(18)]);
				this.form.controls.cpfCnpj.updateValueAndValidity();
			}

			// set the new value
			this.cpfCnpjOld = this.cpfCnpj = newVal;
		} else {
			this.cpfCnpj = this.cpfCnpjOld;
		}
	}


	ngOnDestroy() {
		AppEventDispatcher.removeListener(RegisterOfBenefactorsEventType.STEPS.BENEFACTOR_ADD.BENEFACTOR_DATA);
	}

	getStepHeight(): number {
		return $(this.view).outerHeight() + $('.buttons').outerHeight();
	}

	preload(active, delay = 0) {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD,
			{ element: '[data-component="add-benefactors"] .content', show: active, delay: delay });
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/register-of-benefactors/add-benefactors/benefactor-data/benefactor-data.component.ts